export enum ChromeMessageType {
  CONTENT_SCRIPT,
  GET_TRACKING_DATA,
  EXTENSION_CONFIGURED,
  UPLOAD_LOGS_AND_CLEANUP,
  SHOULD_RESTORE_CONTENT,
  CANCEL_TAMPERING_CHECKS,
}

export type ChromeMessage =
  | { type: ChromeMessageType.CONTENT_SCRIPT }
  | { type: ChromeMessageType.GET_TRACKING_DATA }
  | { type: ChromeMessageType.EXTENSION_CONFIGURED }
  | { type: ChromeMessageType.UPLOAD_LOGS_AND_CLEANUP }
  | { type: ChromeMessageType.SHOULD_RESTORE_CONTENT }
  | { type: ChromeMessageType.CANCEL_TAMPERING_CHECKS };

export type EventsReportResult = {
  devicePolicyTimestamp: string | null;
  seconds: number;
};

export enum ProcessUrlResponse {
  BLOCK = -1,
  BLOCK_BY_QUOTA = -2,
  BLOCK_BY_SCHEDULE = -3,
  ALLOW = 1,
  PENDING = 0,
  REDIRECT_TO_SAFE_SEARCH = 8,
  IGNORE = 9,
}

export type TrackingData = {
  deviceUid: string;
  accountUid: string;
  profileId: number;
  profileName: string;
};

export type SegmentProperties = {
  device_uid?: string;
  profile_id?: number;
  profile_name?: string;
};

export type ValueOf<T> = T[keyof T];

// eslint-disable-next-line @typescript-eslint/ban-types
export type DeepPartial<T> = T extends Function
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

/**
 * if the type is an array, return the type of the array's items
 */
export type UnArray<T> = T extends Array<infer U> ? U : T;

export class DeviceAndUserStore {}
